import { component } from 'picoapp';
import { register } from 'swiper/swiper-element-bundle';

register();

class Slider {
  constructor(el, ctx) {
    this.el = el;
    this.ctx = ctx;
    this.init(el);
    this.bindEvents();
  }

  init(el) {
    this.slider = el

    const settingsContainer = el.closest("[class*='wp-block']") || el.parentElement
    this.customSettings = settingsContainer.querySelector('[data-type="slider-settings"]') ? JSON.parse(settingsContainer.querySelector('[data-type="slider-settings"]').text) : {}

    const swiperParams = {
      spaceBetween: 16,
      injectStyles: [
        `
        .swiper:has(.swiper-scrollbar:not(.swiper-scrollbar-lock)),
        .swiper:has(.swiper-pagination:not(.swiper-scrollbar-lock)) {
          padding-bottom: 3rem;
        }
        `,
      ],
    };

    // now we need to assign all parameters to Swiper element
    Object.assign(this.slider, { ...swiperParams, ...this.customSettings });

    this.slider.initialize();
  }
  bindEvents() {
    this.el.swiper.on('slideChange', () => {
      if (this.el.swiper.isEnd) {
        this.el.classList.add('is-end');
      } else {
        this.el.classList.remove('is-end')
      }
    });
  }

}

// module.exports = Slider;
export default component((node, ctx) => {
  new Slider(node, ctx);
});
